import { render, staticRenderFns } from "./BookingProductCardContent.vue?vue&type=template&id=48e3d659&scoped=true&lang=pug&"
import script from "./BookingProductCardContent.vue?vue&type=script&lang=js&"
export * from "./BookingProductCardContent.vue?vue&type=script&lang=js&"
import style0 from "./BookingProductCardContent.vue?vue&type=style&index=0&id=48e3d659&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3d659",
  null
  
)

export default component.exports